import { createHead } from '@unhead/vue/client'
import { createApp } from 'vue'

import { ConsoleTracker, PosthogTracker, trackerPlugin, useTracker } from '@last/core-ui/paprika'

import App from './App.vue'
import i18n from './i18n'
import router from './router'
import rum from './rum'
import { pinia } from './store/pinia'

import './style.css'

const app = createApp(App)
const head = createHead()

app.use(head)
app.use(i18n)
app.use(router)
app.use(pinia)

if (import.meta.env.VITE_POSTHOG_API_KEY) {
  app.use(trackerPlugin, {
    tracker: new PosthogTracker(import.meta.env.VITE_POSTHOG_API_KEY)
  })
} else {
  app.use(trackerPlugin, {
    tracker: new ConsoleTracker()
  })
}

router.afterEach(to => {
  const tracker = useTracker()
  tracker.track('page changed', { path: to.name?.toString() })
  tracker.track(`[page] ${to.name?.toString()}`)
})

rum.setRouter(router)
if (import.meta.env.PROD) {
  app.config.errorHandler = err => {
    rum.addError(err)
  }
}

app.mount('#app')

export { app }
